import {
  CategorizedOptions, Formblock, Popover, Textfield,
} from '@zolteam/zol-admin-ui';
import { useMemo, useRef, useState } from 'react';
// style
import style from './AutcompleteCustomers.module.css';
// services
import { useGetCustomerListQuery } from '../../../services/customers/customersQueries';
import { getFullname } from '../../../domain/customers/customersUseCases';

/**
 * AutocompleteCustomers component.
 * @param {object} props
 * @param {Function} props.setCustomer
 * @param {string} props.label
 * @param {string} props.name
 * @param {{value: string, label: string}} [props.value]
 * @param {string} [props.errorMessage]
 * @param {Function} [props.onBlur]
 * @returns {JSX.Element}
 */
function AutocompleteCustomers({
  setCustomer, value, label, errorMessage = null, name, onBlur,
}) {
  const inputElRef = useRef(null);
  const [search, setSearch] = useState(null);
  const { data: customers } = useGetCustomerListQuery({
    pageNumber: 1,
    pageSize: 10,
    search,
  });

  const customerOptions = useMemo(() => ([{
    label,
    options: customers?.data?.map(
    /**
     * @param {Customer} customer
     * @returns {{ label: string, value: string }}
     */
      (customer) => ({
        label: getFullname(customer.firstname, customer.lastname),
        value: customer.id?.toString(),
      }),
    ) || [],
  }]), [customers]);

  // handlers

  /**
   * Handle the search bar change.
   * @param {import('react').BaseSyntheticEvent} e
   * @returns {void}
   */
  const handleSetSearch = (e) => {
    setCustomer(null);
    setSearch(e.target?.value);
  };

  /**
   * Handle the search bar click.
   * @param {string} code
   * @returns {void}
   */
  const handleSearchClick = (code) => {
    const selected = customerOptions?.[0]?.options?.find(({ value: val }) => val === code);
    setSearch(null);
    setCustomer(selected);
  };

  // renderers
  const getPopoverContent = () => (
    <CategorizedOptions
      options={customerOptions || []}
      onSearchChange={null}
      emptyOptionListLabel="Aucun contenu"
      onItemClick={handleSearchClick}
    />
  );

  return (
    <Formblock
      key={name}
      htmlFor={name}
      label={label}
      message={errorMessage}
      className={style.wrapper}
      color={errorMessage ? 'error' : 'default'}
    >
      <Popover
        className={style.popover}
        handleClassName={style.popover}
        placement="bottom-start"
        content={getPopoverContent()}
        popoverBoxStyle={!search ? { visibility: 'hidden', display: 'none' } : { width: inputElRef?.current?.getBoundingClientRect()?.width }}
        triggerOnce
      >
        <Textfield
          hasError={!!errorMessage}
          ref={inputElRef}
          type="text"
          // @ts-ignore
          placeholder={label}
          name={name}
          value={search === null ? value?.label : search}
          onChange={handleSetSearch}
          onBlur={onBlur}
        />
      </Popover>
    </Formblock>
  );
}

export default AutocompleteCustomers;
